<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-form class="admin-form" @submit.stop.prevent="submitTag">
          <b-form-group horizontal label="Tag Name">
            <b-form-input type="text" v-model="tagObject.name"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Tag Color">
            <chrome-picker v-model="tagObject.color" />
          </b-form-group>
          <b-form-group horizontal label="Hex Code">
            <b-form-input v-model="tagObject.color.hex"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </div>
      <div class="col-md-4">
        <span v-if="tagObject.name" class="tag" :style="{ background: tagObject.color.hex }">
          {{tagObject.name}}
        </span>
      </div>
    </b-row>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
export default {
  name: 'NewTag',
  data () {
    return {
      tagObject: {
        color: {
          hex: '#19ad33'
        },
        name: ''
      },
      colorsCollection: [
        'gray',
        'green',
        'blue',
        'orange',
        'purple',
        'red'
      ]
    }
  },
  components: {
    'chrome-picker': Chrome
  },
  methods: {
    submitSuccessful () {
      this.tagObject.name = ''
      this.tagObject.color = ''
      this.tagObject.id = null
      this.$root.$emit('tagWasAdded')
      this.$store.dispatch('loadTags')
    },
    submitTag () {
      var vm = this
      if (this.tagObject.id) {
        this.$http.put('/tags/' + this.tagObject.id, {tag: {name: this.tagObject.name, color: this.tagObject.color.hex}})
          .then(response => vm.submitSuccessful(response))
          .catch(e => { console.log(e) })
      } else {
        this.$http.post('/tags', {tag: {name: this.tagObject.name, color: this.tagObject.color.hex}})
          .then(response => vm.submitSuccessful(response))
          .catch(e => { console.log(e) })
      }
    }
  },
  mounted () {
    this.$root.$on('editTag', (data) => {
      this.tagObject.name = data.name
      this.tagObject.color = { hex: data.color }
      this.tagObject.id = data.id
    })
  }
}
</script>
<style scoped>
  .color-select {
    border: 1px solid #f2f3f4;
    display: block;
    width: 100%;
    height: 100%;
  }
  .gray {
    background: #f2f3f4;
   }
  .green {
     background: #4dbd7c;
   }
  .blue {
     background: #2f44d6;
   }
  .orange {
    background: #f98b33;
   }
  .purple {
    background: #7e81e7;
  }
  .red {
    background: #e02e28;
  }
  .colors li {
    background: #f2f3f4;
    border-radius: 2px;
    border: 1px solid #f2f3f4;
    display: inline-block;
    margin: 0 6px;
  }
  .selected-color {
    border: 1px solid #4e769e!important;
  }
  .colors b {
      width: 11px;
      height: 11px;
      border-radius: 2px;
      cursor: pointer;
      display: block;
      margin: 1px;
  }
  .tag {
    border-radius: 2px;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    padding: 12px 16px;
    cursor: pointer;
    line-height: 12px;
    margin: 6px 2px 0px 1px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/NewTag.vue